<template>
  <div class="tkDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games" v-for="(item,i) in setDetail.img">
        <a href=""><img :src="baseUrl+item"></a>
      </swiper-slide>
      <!--<div class="swiper-pagination" slot="pagination"></div>-->
    </swiper>
    <div class="cont">
      <div class="info">
        <h2 class="title"><div>{{setDetail.title}}</div>
          <span class="curt">{{setDetail.level}}级景区</span>
          <span>{{setDetail.read_num}}次查阅</span>
        </h2>
        <h2 style="padding-bottom:10px">
          <p>周一至周日</p>
          <p>入场时间：{{setDetail.business}}</p>
          <p>以上信息仅供参考，具体以景区当日实际公示信息为准。</p>
        </h2>
        <h2 class="box" @click="uls">
          <div class="aleft">景区地址：{{setDetail.address}}</div>
          <font class="distance">{{setDetail.distance}}KM<em class="el-icon-arrow-right"></em></font>
        </h2>
        <h2 class="box">咨询电话：<a :href="'tel:'+setDetail.tel">{{setDetail.tel}}</a></h2>
        <div class="goDetail" @click="toPush(setDetail.id,'tkscenic')">详情<i class="el-icon-arrow-right"></i></div>
      </div>

      <div class="card" v-if="arr.length > 0">
        <h2>景区门票</h2>
        <ul>
          <li v-for="(item,i) in arr" @click="toPush(item.id,'tkpayment?uid='+uid)">
            <h3>{{item.title}}</h3>
            <div class="rate"><font>有效时间：</font><span>{{item.starttime}} ~ {{item.endtime}}</span></div>
            <div class="price"><font>优惠价：</font>
              <i>￥</i><b>{{item.rate.split(".")[0]}}</b>
              <i>.{{item.rate.split(".")[1]}}</i>
              <span>￥{{item.price}}</span>
            </div>
            <a>购买</a>
          </li>
        </ul>
      </div>
      
      <div class="study" v-if="study.length > 0">
        <h2>附近商家</h2>
        <ul v-if="study.length > 0">
          <li v-for="(item,i) in study" @click="toPush(item.id,'detail')">
            <el-image :src="baseUrl+item.img" fit="cover"></el-image>
            <div class="left">
            <h3>{{item.title}}</h3>
            <div class="source">
              <span>地址:{{item.address}}</span>
              
            </div>
            <div class="source"><span>营业时间:{{item.business}}</span><font>
                <img src="~assets/images/starO.png" />
                {{item.star}}
              </font></div>
            </div>
          </li>
          <li v-for="(item,i) in study" @click="toPush(item.id,'detail')">
            <el-image :src="baseUrl+item.img" fit="cover"></el-image>
            <div class="left">
            <h3>{{item.title}}</h3>
            <div class="source">
              <span>地址:{{item.address}}</span>
              
            </div>
            <div class="source"><span>营业时间:{{item.business}}</span><font>
                <img src="~assets/images/starO.png" />
                {{item.star}}
              </font></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        arr:[],
        positionFlag:false,
        study:[],
        uid:'',
        cityData:[]
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.uid = this.$route.query.uid == undefined ? '' : this.$route.query.uid;
    },
    mounted() {
      this.beforeMount();
      
      this.getDmp();
      if(localStorage.getItem('cCode') == null){
        this.getQquey();
      }else{
        var cCode = JSON.parse(localStorage.getItem('cCode'));
        if(cCode.expires <= Date.parse(new Date())){
          localStorage.removeItem('cCode');
          this.getQquey();
        }else{
          this.cityData = cCode;
          this.getDetail()
        }
      }
      //this.getStudy();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      save:function(){
        alert('请接入客户微信支付，内部微信支付已关停')
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      uls:function(){
        let tengxunH5Url = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:'+this.setDetail.latitude+','+this.setDetail.longitude+';title:'+this.setDetail.title+';addr:'+this.setDetail.address+'&referer=aSPSDxIofuEALG56BcTsXkOHv7g8Pusb';
        window.setTimeout(() => {
          window.location.href = tengxunH5Url;
        }, 10);
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.getDetail();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/latDetail',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setDetail = data.data
            that.fullscreenLoading = false
          }
        })
      },

      getDmp:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/dmp',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.arr = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getStudy:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/mall',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.study = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .tkDetailApp{
    background:#f1f1f1;
    width:100%
  }
  .tkDetailApp .swiper-slide{
    width:100%
  }
  .tkDetailApp .swiper-slide img{
    display:block;
    width:100%;

  }
  .tkDetailApp .cont{
    width:94%;
    display:block;
    margin:0 auto;
    z-index:99;
    position:relative;
    top:-60px;
  }
  .tkDetailApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
    border-radius:6px;
  }
  .tkDetailApp .info .goDetail{
    position:absolute;
    right:3%;
    transform: translateY(-50%);
    top:20%;
    font-size:14px;
    color:#666
  }
  .tkDetailApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .tkDetailApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:15px 0
  }
  .tkDetailApp .info h2.box .aleft{
    float:left;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .tkDetailApp .info h2.box .distance{
    float:right;
    font-size:14px;
    margin-top:3px;
    color:#666
  }
  .tkDetailApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .tkDetailApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .tkDetailApp .info h2.title div{
    margin-bottom:8px
  }
  .tkDetailApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
  }
  .tkDetailApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .tkDetailApp .info h2 a{
    color:#2F78FF;
    text-decoration: none;
  }

  .tkDetailApp .card{
    width:100%;
    display:block;
  }
  .tkDetailApp .card h2{
    font-size:16px;
    position:relative;
    padding:15px 0 10px 10px
  }
  .tkDetailApp .card h2:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:19px;
    border-radius: 3px;
  }
  .tkDetailApp .card ul{
    width:100%;
    display:block;
    margin:0 auto;
    background:#fff;
    border-radius:6px;
    padding:15px 0 10px 0
  }
  .tkDetailApp .card ul li{
    background:#f5f5f5;
    border-radius:6px;
    width:92%;
    margin:0 auto 10px auto;
    position:relative;
  }
  .tkDetailApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    color:#333
  }

  .tkDetailApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .tkDetailApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 5px 15px;
    color:#999
  }
  .tkDetailApp .card ul li .price font{
    color:#999;
    font-size:15px;
  }
  .tkDetailApp .card ul li .price b{
    color: #f00;
    font-size:17px;
    font-weight:bold;
  }

  .tkDetailApp .card ul li .price i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }
  .tkDetailApp .card ul li .price span{
    text-decoration: line-through;
    padding-left:8px;
    font-size:12px
  }
  .tkDetailApp .card ul li a{
    position:absolute;
    right:20px;
    top:60%;
    background: linear-gradient(90deg, #F79169, #FFAA3B);
    transform: translateY(-50%);
    color:#fff;
    border-radius: 30px;
    width: 65px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-size:14px;
  }

  .tkDetailApp .video{
    width:100%;
    margin:0 auto;
  }

  .tkDetailApp .video-js .vjs-big-play-button {
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    outline: none!importrant;
  }
  .tkDetailApp .study h2{
    font-size:16px;
    position:relative;
    padding:15px 0 10px 10px
  }
  .tkDetailApp .study h2:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:19px;
    border-radius: 3px;
  }
  .tkDetailApp .study ul{
    width: 100%;
    background:#fff;
    padding-top:15px
  }
  .tkDetailApp .study ul li{
    width: 92%;
    background:#fff;
    border-radius: 5px;
    margin:0 auto 12px auto;
    border-bottom:1px solid #f5f5f5;
    padding-bottom:10px
  }
  .tkDetailApp .study ul li:last-child{
    border-bottom:0
  }
  .tkDetailApp .study ul li:after,.tkDetailApp .info .box::after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .tkDetailApp .study ul li .el-image{
    float:left;
    width:25%;
    height:70px;
  }
  .tkDetailApp .study ul li .el-image__inner{
    border-radius:5px;
  }
  .tkDetailApp .study ul li .left{
    float:left;
    width:75%
  }
  .tkDetailApp .study ul li h3{
    display:block;
    font-size:15px;
    letter-spacing:1px;
    padding:0px 0px 0px 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:1;
    overflow: hidden;
    color:#000;
    padding-bottom:4px
  }
  .tkDetailApp .study ul li .source{
    padding: 0 10px 0px 5px
  }
  .tkDetailApp .study ul li .source:after{
    content:"";
    display: block;
    clear:both;
  }
  .tkDetailApp .study ul li .source img{
    width:25px;
    border-radius:50%;
    float:left;
    margin-left:10px;
  }
  .tkDetailApp .study ul li .source span{
    float:left;
    color:#333;
    font-size:14px;
    height:25px;
    line-height:25px;
    margin-left:5px;
  }
  .tkDetailApp .study ul li .source font{
    float:right;
    color:#333;
    font-size:14px;
    height:25px;
    line-height:25px;
  }
  .tkDetailApp .study ul li .source font img{
    width:16px;
    position:relative;
    top:3px;
    margin-right:3px
  }

</style>